<template>
	<div class="kr-layout-content">
		<div class="adaption-top">
			<div class="logo">
				<img src="../../assets/img/logo.png" alt />
			</div>
			<div class="open" @click.stop="adaptionShow">立即打开</div>
			<div v-if="adaption" class="open-code">
				<img src="../../assets/img/code.png" alt />
			</div>
		</div>
		<div class="kr-home">
			<!--广告-->
			<div class="banner-top">
				<a :href="adv.hrefUrl" target="_blank">
					<img :src="adv.picUrl" alt />
				</a>
			</div>
			<div class="kr-home-banner clearfloat">
				<!--左边轮播图-->
				<div class="kr-home-banner-left">
					<!-- <div class="block" style="height:100%">
            <el-carousel trigger="click" height="360px">
              <el-carousel-item v-for="item in banner" :key="item">
               <img :src="item.pic" alt />
              </el-carousel-item>
            </el-carousel>
          </div>-->
					<div class="swiper-container lunbo">
						<div class="swiper-wrapper" id="banner">
							<div class="swiper-slide" v-for="(item,index) in banner" :key=" index "
								@click="detailss(item.id,item.type)">
								<img :src="item.pic" alt />
								<p class="title oneline">{{item.title}}</p>
							</div>
						</div>
						<div class="swiper-pagination"></div>
					</div>
				</div>
				<!--右边四个图-->
				<!-- <div class="banner-right">
          <div
            v-for="(item,index) in Recom"
            :key="index"
            class="right-list"
            @click="ptDetails(item.id)"
          >
            <img :src="item.picUrl" alt />
            <div class="intro">
              <p class="twoline">{{item.title}}</p>
            </div>
          </div> -->
				<div class="banner-right" style="overflow: hidden;">
					<div v-for="(item,index) in newArtical1" :key="index" class="right-list"
						v-if="item.isTop==1 && index>=4" @click="details(item.id)">
						<img :src="item.pic" alt />
						<div class="intro">
							<p class="twoline">{{item.title}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--左边-->
		<div class="content-left">
			<!--最新文章-->
			<div class="new-article">
				<p class="top">推荐文章</p>
				<ul class="art-list">
					<li v-for="(item,index) in newArtical" v-if="item.isTop==1" :key="index" @click="details(item.id)">
						<div class="head-img">
							<img :src="item.pic" alt />
						</div>
						<div class="content">
							<div class="title">
								<!-- <span>{{item.articleCategory}}</span> -->
								<p class="twoline">{{item.title}}</p>
							</div>
							<!-- <p class="intro oneline">{{item.subTitle}}</p> -->
							<div class="author">
								<div class="author-img">
									<img :src="item.userHeadPic" alt />
								</div>
								<p class="name">
									{{item.userName }}
									<span>.</span>
									{{item.createTime}}
								</p>
							</div>
						</div>
					</li>
				</ul>
			</div>

			<!--专题推荐-->
			<div class="new-article">
				<p class="top  sp" style="margin:40px 0px 0px;">
					专题推荐
					<span class="fr" @click="lookMoreTrans('/special')">查看更多</span>
				</p>
				<ul class="act-list sp">
					<li v-for="(item,index) in spacial" :key="index" @click="speDetails(item.id,item.pic)">
						<div class="act-img">
							<img :src="item.pic" alt />
						</div>
						<div class="act-cont">
							<p class="threeline" v-html="item.des"></p>
						</div>
					</li>
				</ul>
				<!--专题推荐列表-->
				<ul class="art-list">
					<li v-for="(item,index) in spaBottom" :key="index" @click="details(item.id)">
						<div class="head-img">
							<img :src="item.pic" alt />
						</div>
						<div class="content">
							<div class="title oneline">
								<!-- <span>艺术</span> -->
								<p class="sub oneline" style="width:100%">{{item.title}}</p>
							</div>
							<div class="author">
								<div class="author-img">
									<img :src="item.userHeadPic || ''" alt />
								</div>
								<p class="name">
									{{item.userName }}
									<span>.</span>
									{{item.createTime}}
								</p>
							</div>
						</div>
					</li>
				</ul>
			</div>

			<!--视频推荐-->
			<div class="new-article">
				<p class="top vid" style="margin-bottom:0px;">
					视频推荐
					<span class="fr vid" @click="lookMoreTrans('/video')">查看更多</span>
				</p>
				<!--三个列表-->
				<ul class="act-list vid">
					<li v-for="(item,index) in video" :key="index" @click="videoDetails(item.id)">
						<div class="act-img">
							<img :src="item.pic" />
							<i class="iconfont icon-shipin"></i>
							<span class="video-time-length">{{item.videoDuration}}</span>
						</div>
						<div class="act-cont">
							<p class="threeline">{{item.content}}</p>
						</div>
					</li>
				</ul>
				<!--视频推荐列表-->
				<ul class="art-list">
					<li v-for="(item,index) in videoBottom" :key="index" @click="details(item.id)">
						<div class="head-img">
							<img :src="item.pic" alt />
						</div>
						<div class="content">
							<div class="title">
								<!-- <span>{{item.articleCategory}}</span> -->
								<p class="oneline" style="width:100%;">{{item.title}}</p>
							</div>
							<!-- <p class="intro oneline">{{item.content}}</p> -->
							<div class="author">
								<div class="author-img">
									<img :src="item.userHeadPic" alt />
								</div>
								<p class="name">
									{{item.userName}}
									<span>.</span>
									{{item.createTime}}
								</p>
							</div>
						</div>
					</li>
				</ul>
				<div v-if="loadmore" class="look-more" @click="videoMore">查看更多</div>
				<p v-if="!loadmore" class="none-more">没有更多了</p>
			</div>
		</div>

		<!--右边-->
		<div class="content-right">
			<!--活动播报-->
			<div class="new-right">
				<!--最新播报-->
				<div class="act" v-if="hdList.length > 0">
					<div class="bg">
						<div class="topic-top">
							<div class="topic fl">活动播报</div>
							<div class="time fr">
								<div class="fl day">{{day}}</div>
								<div class="fr date">
									<p>{{nowTime.xingqi}} {{lunar}}</p>
									<p>{{nowTime.curenttime2}}</p>
								</div>
							</div>
						</div>
						<div class="cont" style="cursor:pointer">
							<div class="bobao_bm swiper-container wenzi_left">
								<div class="swiper-wrapper">
									<div class="swiper-slide gundong" v-for="(item,index) in hdList" @click="details(item.id)" >
										<p class="title twoline">
											<span>播报</span>
											{{item.title}}
										</p>
									</div>
								</div>
							</div>
							<!-- <p class="title twoline">
                <span>播报</span>
                {{activity.title}}
              </p> -->
						</div>
					</div>
				</div>
				<div class="report-list">
					<div class="top">
						<img src="../../assets/img/msg.png" alt /> 最新资讯
					</div>
					<ul>
						<li v-for="(item,index) in actList" :key="index" @click="details(item.id)">
							<div class="ball"></div>
							<p v-html="item.title"></p>
							<p class="time">{{item.createTime}}</p>
						</li>
					</ul>
				</div>
				<div v-if="newsLoad" class="look-more" @click="newsMore">查看更多</div>
				<p v-if="!newsLoad" class="none-more">没有更多了</p>
			</div>

			<!--24小时热点-->
			<div class="hot" v-if="hotd">
				<div class="top">
					<img src="../../assets/img/msg.png" alt /> 24小时热点
				</div>
				<ul class="hot-list">
					<li v-for="(item,index) in hotspot" :key="index" @click="details(item.id)">
						<img :src="item.pic" />
						<p class="oneline">{{item.title}}</p>
					</li>
				</ul>
			</div>
			<ul class="little-hot little-new">
				<li v-for="(item,index) in hotspotLittle" :key="index" @click="details(item.id)">
					<div class="new-img">
						<img :src="item.pic" alt />
					</div>
					<div class="content" style="position:relative">
						<p class="threeline">{{ item.title }}</p>
						<p style="position:absolute;bottom:0px;">{{item.createTime}}</p>
					</div>
				</li>
			</ul>

			<!--精选媒体人-->
			<div class="hot">
				<div class="top">
					<img src="../../assets/img/msg.png" alt /> 精选媒体人
				</div>
			</div>
			<div class="hot media" style="margin-top:0px;">
				<ul class="little-new">
					<li v-for="item in media" :key="item.id" @click="author(item.id)">
						<div class="sift-top" style="position:relative">
							<div class="new-img">
								<img :src="item.pic" alt />
							</div>
							<div class="content" style="position:static">
								<p class="threeline">{{item.nickName}}</p>
								<p class="twoline" style="position:absolute;bottom:0px;">{{item.des}}</p>
							</div>
						</div>
						<!-- <p class="caption">{{item.orgName}}</p> -->
						<p class="time"></p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	// import Vue form '首页';
	import $ from "jquery";
	import Swiper from "swiper";
	import wx from "weixin-js-sdk";
	export default {
		// name: "App",
		data() {
			return {
				adv: {},
				banner: [],
				Recom: [],
				spacial: [],
				spaBottom: [],
				video: [],
				videoBottom: [],
				newArtical: [],
				newArtical1: [],
				media: [],
				activity: {
					id: '',
					title: '',
				},
				actList: [],
				nowTime: "",
				day: "",
				lunar: "",
				hotspot: [],
				hotspotLittle: [],
				curPage: 1,
				newsPage: 1,
				loadmore: true,
				newsLoad: true,
				totalPage: 0,
				newsTotal: 0,
				adaption: false,
				nowTime: '',
				hotd: true,
				hdList: []
			};
		},
		computed: {
			role() {
				return this.$store.state.userInfo.role;
			}
		},
		mounted() {
			this.getAdv();
			this.getSwiper();
			this.getRecom();
			this.getSpa();
			this.getSpaBottom();

			this.getVideo();
			this.getVidBottom();
			this.getArtical();
			this.getArtical2()
			this.getAvtivity();
			this.actBobao();

			this.getMedia();
			this.getNowtime();
			this.hotSpot(); //24小时热点
			this.hotSpotLittle();
			this.getHdList();



			this.checkWx()

		},
		filters: {
			imglize(value) {
				if (!value) return "";
				return value + "?x-oss-process=image/crop,x_900,y_100";
			}
		},
		methods: {

			adaptionShow() {
				var u = navigator.userAgent;
				var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
				var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
				if (isiOS && isIos == 'IOS') {
					window.location.href = 'https://apps.apple.com/cn/app/heart-language-icle/id1476235011';
				} else {
					window.location.href = 'https://appgallery1.huawei.com/#/app/C101555263';
				}
				return false
				this.adaption = !this.adaption;
				const fn = () => {
					this.adaption = !this.adaption;
					document.removeEventListener("click", fn);
				};
				document.addEventListener("click", fn, false);
			},
			getHdList() {
				//活动播报
				this.$http
					.post("/api/006-activityList", {
						params: {
							pageNo: 1
						}
					})
					.then(res => {
						console.log(res, "广告");
						if (res.status == 200 && res.data.code == 0) {
							this.hdList = res.data.rows;
							this.$nextTick(function() {
								new Swiper(".wenzi_left", {
									autoplay: {
										delay: 5000,
										stopOnLastSlide: false,
										disableOnInteraction: true,
									},
									touchRatio: 0,
									loop: true
								});
							});
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			checkWx() {
				var that = this;
				var title = '建筑档案—你也可以很懂建筑'
				var desc = '建筑行业全产业链内容共建平台，融媒体运营服务与产品创新型平台'
				var imgUrl = 'https://www.jzda001.com/app/shareLogo.png'
				this.$http
					.post("/api/wx/xiaochengxu/JSSDKConfig", {
						url: location.href.split("#")[0]
					})
					.then(res => {
						console.log(res, "小程序等");
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: res.data.appId, // 必填，公众号的唯一标识
							timestamp: res.data.timestamp, // 必填，生成签名的时间戳
							nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
							signature: res.data.signature, // 必填，签名
							jsApiList: ["updateAppMessageShareData",
								"updateTimelineShareData"] // 必填，需要使用的JS接口列表
						});

						wx.ready(function() {
							// console.log(window.location.href)
							//需在用户可能点击分享按钮前就先调用
							wx.updateAppMessageShareData({
								title: title, // 分享标题
								desc: desc, // 分享描述
								link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
								imgUrl: imgUrl, // 分享图标
								success: function() {
									// 设置成功
								}
							});
							wx.updateTimelineShareData({
								title: title, // 分享标题
								link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
								imgUrl: imgUrl, // 分享图标
								success: function() {
									// 设置成功
								}
							});
						});
						wx.error(function(res) {
							// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
						});
					})
					.catch(err => {
						console.log(err);
					});
			},
			getAdv() {
				//广告
				this.$http
					.get("/api/005-adList", {
						params: {
							type: 2
						}
					})
					.then(res => {
						console.log(res, "广告");
						if (res.status == 200 && res.data.code == 0) {
							this.adv = res.data.rows[0];
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			getSwiper() {
				//轮播
				this.$http
					.get("/api/002-bannerList")
					.then(res => {
						console.log(res, "轮播");
						if (res.status == 200 && res.data.code == 0) {
							this.banner = res.data.rows;
							this.$nextTick(function() {
								new Swiper(".lunbo", {
									loop: true,
									autoplay: {
										delay: 2000,
										disableOnInteraction: false
									},
									pagination: {
										el: ".swiper-pagination",
										clickable: true
									}
								});
							});
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			getRecom() {
				//获取推荐信息
				this.$http
					.get("/api/zhaoPin/zhaoPinList", {
						params: {
							isTuiJian: 1,
							limit: 4
						}
					})
					.then(res => {
						console.log(res, "右侧推荐信息");
						if (res.status == 200 && res.data.code == 0) {
							this.Recom = res.data.rows;
						}
					});
			},
			getSpa() {
				//获取专题推荐
				this.$http
					.get("/api/core/015--zhuanTiList", {
						params: {
							isTop: 1,
							limit: 3
						}
					})
					.then(res => {
						console.log(res, "专题推荐");
						if (res.status == 200 && res.data.code == 0) {
							this.spacial = res.data.rows;
						}
					});
			},
			getVideo() {
				//获取视频推荐
				this.$http
					.get("/api/core/002--newsList", {
						params: {
							type: 2,
							limit: 3
						}
					})
					.then(res => {
						console.log(res, "视频推荐");
						if (res.status == 200 && res.data.code == 0) {
							this.video = res.data.rows;
						}
					});
			},
			getArtical() {
				//获取最新文章
				this.$http
					.get("/api/core/002--newsList", {
						params: {
							type: 1,
							limit: 4
						}
					})
					.then(res => {
						console.log(res, "推荐文章");
						if (res.status == 200 && res.data.code == 0) {
							this.newArtical = res.data.rows;
						}
					});
			},
			getArtical2() {
				//获取最新文章
				this.$http
					.get("/api/core/002--newsList", {
						params: {
							type: 1,
							limit: 10
						}
					})
					.then(res => {
						console.log(res, "推荐文章2");
						if (res.status == 200 && res.data.code == 0) {
							this.newArtical1 = res.data.rows;
						}
					});
			},
			getSpaBottom() {
				//获取专题推荐
				this.$http
					.get("/api/core/002--newsList", {
						params: {
							type: 1,
							limit: 11
						}
					})
					.then(res => {
						console.log(res, "专题推荐小");
						if (res.status == 200 && res.data.code == 0) {
							var arr = res.data.rows.slice(4)
							this.spaBottom = arr;
						}
					});
			},
			getVidBottom() {
				//获取视频推荐
				this.$http
					.get("/api/core/002--newsList", {
						params: {
							type: 1,
							limit: 20,
							pageNo: this.curPage
						}
					})
					.then(res => {
						console.log(res, "视频推荐列表");
						if (res.status == 200 && res.data.code == 0) {
							this.videoBottom.push(...res.data.rows.slice(11));
							if (this.curPage >= res.data.totalPage) {
								this.loadmore = false;
							}
							this.curPage++;
						}
					});
			},
			videoMore() {
				//查看更多
				this.getVidBottom();
			},
			getAvtivity() {
				//最新活动
				this.$http
					.get("/api/core/033--latelyNewsList", {
						params: {
							// articleCategory: 10,
							type: 1,
							pageNo: this.newsPage
						}
					})
					.then(res => {
						console.log(res)
						if (res.status == 200 && res.data.code == 0) {
							this.actList = res.data.rows;
							if (this.newsPage >= res.data.totalPage) {
								this.newsLoad = false;
							}
							this.newsPage++;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			actBobao() {
				this.$http
					.get("/api/006-activityList")
					.then(res => {
						console.log(res, "活动列表");
						if (res.status == 200 && res.data.code == 0) {
							this.activity.id = res.data.rows[0].id;
							this.activity.title = res.data.rows[0].title;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			newsMore() {
				//查看更多
				this.getAvtivity();
			},
			getNowtime() {
				//获取当前时间
				this.$http
					.get("/api/007-getCurrentSystemTime")
					.then(res => {
						if (res.status == 200 && res.data.code == 0) {
							this.nowTime = res.data.rows[0];
							this.day = this.nowTime.curenttime.substr(-2, 2);
							this.lunar = this.nowTime.nongli.slice(5);
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			getMedia() {
				this.$http
					.get("/api/user/015-getBestMeiTiRen", {
						params: {
							limit: 10
						}
					})
					.then(res => {
						console.log(res, "精选媒体人");
						if (res.status == 200 && res.data.code == 0) {
							this.media = res.data.rows;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			lookMoreTrans(path) {
				this.$router.push({
					path: path
				});
			},
			detailss(id, type) {
				if (id == '') {
					return false
				}
				if (type == 1) {
					this.$router.push({
						path: "/ghDetails",
						query: {
							id: id,
							type: 1
						}
					});
				} else {
					this.$router.push({
						path: "/vdDetails",
						query: {
							id: id,
							type: 2
						}
					});
				}
				document.documentElement.scrollTop = 0
			},
			details(id, type) {
				//图文详情
				if (id == '') {
					return false
				}
				this.$router.push({
					path: "/ghDetails",
					query: {
						id: id,
						type: 1
					}
				});
				document.documentElement.scrollTop = 0
			},
			speDetails(id, pic) {
				//专题图文详情
				this.$router.push({
					path: "/specialList",
					query: {
						id: id,
						imgUrl: pic
					}
				});
			},
			videoDetails(id) {
				//视频详情
				this.$router.push({
					path: "/vdDetails",
					query: {
						id: id,
						type: 2
					}
				});
			},
			author(id) {
				//作者个人主页
				this.$router.push({
					path: "/personal",
					query: {
						userId: id,
						type: 3
					}
				});
			},
			ptDetails(id) {
				//招聘详情
				this.$router.push({
					path: "/ptDetails",
					query: {
						id: id
					}
				});
			},
			// 获取当前时间
			nowData() {
				var data = new Date();
				var year = data.getFullYear();
				var m = data.getMonth() + 1;
				var d = data.getDate();
				if (m >= 1 && m <= 9) {
					m = "0" + m;
				}
				if (d >= 0 && d <= 9) {
					d = "0" + d;
				}
				this.nowTime = year + '-' + m + '-' + d
			},
			hotSpot() {
				this.nowData();
				this.$http
					.get("/api/core/002--newsList", {
						params: {
							type: 1,
							limit: 4,
							createTime: this.nowTime
						}
					})
					.then(res => {
						console.log(res, "24小时热点");
						if (res.status == 200 && res.data.code == 0) {
							this.hotspot = res.data.rows;
							if (res.data.rows.length == 0) {
								this.hotd = false
							} else {
								this.hotd = true
							}
						}
					})
					.catch(err => {
						console.log(err);
					});
			},
			hotSpotLittle() {
				this.nowData();
				this.$http
					.get("/api/core/002--newsList", {
						params: {
							type: 1,
							limit: 10,
							createTime: this.nowTime
						}
					})
					.then(res => {
						console.log(res, "24小时热点小列表");
						if (res.status == 200 && res.data.code == 0) {
							this.hotspotLittle = res.data.rows.slice(4);
						}
					})
					.catch(err => {
						console.log(err);
					});
			}
		}
	};
</script>
<style scoped>
	.new-article .art-list>li {
		width: calc(100% - 10px)
	}

	.media .little-new li .content .jieshao {}

	.new-article .art-list>li .content .author .author-img {
		margin-right: 10px;
	}

	.media .little-new li::after {
		width: 100%
	}

	.new-article .top span {
		font-size: 16px;
		font-weight: normal;
		margin-right: 40px;
		color: #999;
		line-height: 30px;
		cursor: pointer;
	}

	.adaption-top {
		display: none;
	}

	.content-left {
		padding-top: 0px;
	}

	.content-right {
		padding-top: 0px;
	}

	.act-list {
		margin: 0px 0px 0px -25px;
	}

	.act-list li {
		width: 32%;
		border: 6px solid #fff;
		transition: all 0.3s linear;
		margin: 0px 7px 20px 0px;
	}

	.act-list li:last-child {
		margin-right: 0px;
	}

	.act-list li:hover {
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
		transition: all 0.3s linear;
	}

	.act-list li .act-img {
		position: relative;
	}

	.act-list li .act-cont {
		box-shadow: none;
		padding-top: 8px;
		background: #eaf2ec;
	}

	.act-list li .act-cont p {
		font-size: 14px;
		color: #333;
		line-height: 18px;
	}

	.new-right .look-more {
		margin: 20px auto;
	}

	/* .new-article .art-list {
  margin-left: -10px;
} */
	.icon-shipin {
		font-size: 40px;
	}

	.video-time-length {
		right: 0px;
	}

	.new-article .top {
		margin: 20px 0px 10px;
	}

	.author-img img {
		vertical-align: unset;
	}

	@media (min-width: 1367px) {
		.act-list li {
			height: 215px;
		}
	}

	@media (min-width: 320px) and (max-width: 414px) {
		.kr-home .kr-home-banner {
			margin-top: 0px;
		}

		.swiper-pagination {
			text-align: center;
		}

		.act-list {
			margin: 0px;
			padding: 0px;
		}

		.act-list li {
			width: 100%;
		}

		.new-article .art-list>li .content .author .name {
			font-size: 13px;
		}

		.new-article .art-list>li .content .title p {
			font-size: 16px;
		}

		.new-article .top {
			margin: 20px 0px 5px 0px;
			font-size: 18px;
			font-weight: 500;
		}

		.kr-home .banner-top {
			display: none;
		}

		.kr-home-banner-left .swiper-wrapper .swiper-slide p {
			/* display: none; */
			font-size: 14px;
			bottom: 8px;
		}

		.banner-right,
		.vid,
		.sp,
		.content-right {
			display: none;
		}

		.swiper-container-horizontal>.swiper-pagination-bullets {
			left: 0px;
			bottom: 25px;
		}

		/* 头部隐藏 */
		.adaption-top {
			display: block;
			width: calc(100% - 24px);
			height: 50px;
			position: fixed;
			top: 0px;
			z-index: 988;
			background: #fff;
		}

		.adaption-top::after {
			content: "";
			width: 110%;
			height: 1px;
			background: #bbb;
			position: absolute;
			left: -12px;
			right: 0px;
			bottom: 0px;
		}

		.adaption-top .logo {
			width: auto;
			height: 26px;
			margin-top: 12px;
			float: left;
		}

		.adaption-top .logo img {
			height: 100%;
			width: auto;
		}

		.adaption-top .open {
			width: 80px;
			height: 26px;
			text-align: center;
			line-height: 26px;
			color: #0a8228;
			margin-top: 12px;
			float: right;
			border: 1px solid #0a8228;
		}

		.adaption-top .open-code {
			width: 70px;
			height: 70px;
			padding: 8px 3px 3px;
			position: absolute;
			right: 6px;
			top: 40px;
			background: url("../../assets/img/code-bg.png") no-repeat;
			background-size: 100% 100%;
		}
	}
</style>
<style>
	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}

	@media (min-width: 320px) and (max-width: 414px) {
		.new-article .art-list {
			display: block !important
		}

		.new-article .art-list>li .content .author {
			height: 28px !important;
		}

		.new-article .art-list>li .content .title p {
			font-size: 17px !important;
		}
	}

	@media (min-width: 320px) and (max-width: 374px) {
		.kr-home-banner-left {
			height: 180px !important;
		}
	}

	@media (min-width: 376px) and (max-width: 414px) {
		.kr-home-banner-left {
			height: 200px !important;
		}
	}
</style>
